import services from "@/services/service"

class Event {
  _init = async () => {
    return true
  }
  resolve = async (event, data = null) => {
    let _event = {}
    if (!event.type) {
      event = {
        type: event,
        detail: data
      }
    }
    if (event.type === Common.API.EVENT_ENUM.GET_HIGHTLIGHT) {
      _event.name = "applicationFocusing"
      _$.sleep(1000).then(() => __.device._registerKeys())
    } else if (event.type === Common.API.EVENT_ENUM.LOSE_HIGHTLIGHT) {
      _event.name = "applicationUnfocused"
    } else if (["playing", "ended", "stopped", "pause", "error"].indexOf(event.type) >= 0) {
      let tempName
      switch (event.type) {
        case "playing":
          tempName = "mediaPlaying"
          break
        case "ended":
          tempName = "mediaEnded"
          break
        case "pause":
          tempName = "mediaPaused"
          break
        case "stopped":
          tempName = "mediaStopped"
          break
        default:
          tempName = "mediaError"
          break
      }
      _event.name = tempName
    } else if (event.type === "powerEvent") {
      _event.name = "power"
      _event.data = event.detail
    } else if (event.type === "sourceEvent") {
      _event.name = "source"
      _event.data = event.detail?.toString()
    } else if (event.type === "data_received") {
      let socketData = null
      try {
        if (event.detail === "newMessage") return services.action.initAjax(false, true)
        socketData = window.atob(event.detail)
        socketData = JSON.parse(socketData)
      } catch (e) {
        return _$.error(e)
      }
      if (socketData.hasOwnProperty("action")) _$.vue.$emit("action", socketData)
      else if (socketData.hasOwnProperty("weather")) _$.vue.$emit("weather", socketData)
      else if (socketData.hasOwnProperty("chromecast")) _$.vue.$emit("chromecast", socketData)
      else if (socketData.hasOwnProperty("rc")) _$.vue.$emit("rc-command", socketData)
      return false
    }
    return _event
  }
}

export default Event
